import { InputAdornment, MenuItem, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const roles = {
  wrapper: "select-wrapper",
  input: "select-input",
  label: "select-label",
};

/**
 * AutoComplete input
 * @param {Object} props
 * @param {String} props.id Input unique id Required
 * @param {*} props.value Input Return Value
 * @param {Function} props.hookSearch hook return data
 * @param {String} props.hookDataKey key of search for the hook (ex : name or multisearch)
 * @param {String} props.optionValueKey key value of data return by hook (ex : _id)
 * @param {String} props.optionLabelKey key label of option (ex : name)
 * @param {String} props.hookDataKey label of option
 * @param {Function} props.onChange onChange method
 * @param {Number} props.delay delay for the data filter or hook search run after last input typing
 * @param {Object} props.filters hook additionnal filters Optionnal
 * @param {Boolean} props.error Apply different style if error is true
 * @param {Boolean} props.multiple if input is multiple ( need to check value)
 * @param {Function} props.icon Component will add icon to textfield adornment.
 * @deprecated
 */
export const Select = ({ verify, error, data, value, showNoneOption, onChange, icon, role, ...props }) => {
  const [selectError, setSelectError] = useState(error || false);
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value);
    if (verify && typeof verify === "function") {
      setSelectError(!verify(value));
    }
  }, [verify, value]);

  useEffect(() => {
    if (typeof error === "boolean") {
      setSelectError(error);
    }
  }, [error]);

  const _onChange = (evt) => {
    const { value } = evt.target;
    setInputValue(value);
    onChange && onChange(evt);
  };

  const params = {};
  if (icon) {
    params.InputProps = {};
    params.InputProps.startAdornment = (
      <>
        <InputAdornment position="start">{icon}</InputAdornment>
        {params.InputProps.startAdornment}
      </>
    );
  }
  return (
    <TextField
      select
      fullWidth
      role={role || roles.input}
      error={selectError}
      value={inputValue}
      onChange={_onChange}
      variant="outlined"
      {...params}
      {...props}
      slotProps={{
        select: Object.assign(
          {
            MenuProps: {
              sx: {
                "& .MuiPopover-paper": {
                  m: 0,
                  p: 0,
                },
              },
            },
          },
          props
        )
      }}>
      {showNoneOption && (
        <MenuItem value={""}>
          <em>Aucun</em>
        </MenuItem>
      )}
      {data.map(({ label, value }, index) => {
        const key = `item-${index}-${label}-${new Date().getTime()}`;
        return (
          <MenuItem key={key} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
